import { Box, CardMedia, useMediaQuery } from "@mui/material";

export default function HeroMedia() {
    const isMobile = useMediaQuery('(max-width:950px)')

    return (
        <Box sx={{
            position: 'relative',
            mx: 'auto',
            marginTop: isMobile ? 4 : 0,
            width: { xs: '240px', sm: '270px' },
            height: { xs: '510px', sm: '560px' },
            border: '6px solid #fff',
            borderRadius: '36px',
            overflow: 'hidden',
            backgroundColor: '#000',
            boxShadow: '0 6px 16px rgba(0,0,0,0.25)',
        }}>
            <CardMedia
                muted
                playsInline
                component="video"
                src="/videos/hero-video-web.mp4"
                title="Vibio in action mockup"
                autoPlay
                loop
                sx={{
                    m: 0,
                    p: 0,
                    width: "100%",
                    height: "100%",
                    border: 'none',
                    pointerEvents: 'none',
                    display: 'block',
                    objectFit: 'cover',
                }}
            />
        </Box>
    )
}